export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20coral%20red%20and%20dark%20charcoal%20tones%2C%20modern%20editorial%20atmosphere%2C%20subtle%20geometric%20textures%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20entertainment%20media%20theme%2C%20dark%20dramatic%20mood%20with%20warm%20highlights%2C%20no%20text%20no%20people%2C%20abstract%20composition&width=1920&height=1080&seq=hero-bg-gossip-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="px-3 py-1 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-300 text-xs font-medium whitespace-nowrap">
                #明星爆瓜
              </span>
              <span className="px-3 py-1 rounded-full bg-accent-500/20 border border-accent-400/30 text-accent-300 text-xs font-medium whitespace-nowrap">
                #吃瓜现场
              </span>
              <span className="px-3 py-1 rounded-full bg-white/10 border border-white/20 text-white/80 text-xs font-medium whitespace-nowrap">
                #每日更新
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white leading-tight mb-3">
              每日吃瓜
              <span className="block text-primary-400 md:inline md:ml-3">— 必吃大瓜视频一站式追更平台</span>
            </h1>

            <p className="text-accent-300 text-lg md:text-xl font-heading mb-6">
              热门大瓜不错过，高清视频随时看
            </p>

            <p className="text-white/75 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              每日吃瓜汇集全网最热明星大瓜视频、吃瓜现场实录与爆瓜合集，覆盖娱乐圈最新动态、综艺爆料、恋情曝光等热门话题。每日更新高清吃瓜视频，不卡顿、不遗漏，让你随时随地追更最新大瓜，做朋友圈里消息最灵通的瓜友。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">2000+</div>
                <div className="text-xs text-white/55 mt-1">高清瓜视频</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">每日更新</div>
                <div className="text-xs text-white/55 mt-1">新鲜大瓜不断</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">高清不卡</div>
                <div className="text-xs text-white/55 mt-1">流畅观看体验</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-colors text-sm cursor-pointer"
              >
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
                立即吃瓜
              </a>
              <a
                href="#ranking"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 text-white border border-white/25 rounded-lg transition-colors text-sm cursor-pointer"
              >
                <i className="ri-bar-chart-line w-4 h-4 flex items-center justify-center"></i>
                查看热度榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] bg-background-900/30 border border-white/10">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20illustration%20of%20entertainment%20gossip%20and%20news%20culture%2C%20warm%20coral%20red%20and%20dark%20tones%2C%20modern%20magazine%20cover%20aesthetic%2C%20dynamic%20composition%20with%20geometric%20shapes%20and%20abstract%20camera%20lens%20elements%2C%20cinematic%20lighting%2C%20bold%20contrast%2C%20dramatic%20shadows%2C%20no%20text%20no%20people&width=800&height=1000&seq=hero-visual-gossip&orientation=portrait"
                alt="每日吃瓜 - 必吃大瓜视频一站式追更平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-5">
                <div className="flex items-center gap-2 text-white/90 text-xs">
                  <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
                  <span>今日已更新 12 条爆瓜视频</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}